/**
 * Tax Filings feature types.
 * Draft statuses: PENDING_CLIENT → CLIENT_VERIFIED | CLIENT_REJECTED
 * Declaration kinds: UNSIGNED | SIGNED
 */

export const DRAFT_COPY_STATUS = {
  PENDING_CLIENT: 'PENDING_CLIENT',
  CLIENT_VERIFIED: 'CLIENT_VERIFIED',
  CLIENT_REJECTED: 'CLIENT_REJECTED',
} as const;

export type DraftCopyStatus =
  (typeof DRAFT_COPY_STATUS)[keyof typeof DRAFT_COPY_STATUS];

export const DRAFT_COPY_STATUS_LABELS: Record<DraftCopyStatus, string> = {
  [DRAFT_COPY_STATUS.PENDING_CLIENT]: 'Pending review',
  [DRAFT_COPY_STATUS.CLIENT_VERIFIED]: 'Verified',
  [DRAFT_COPY_STATUS.CLIENT_REJECTED]: 'Rejected',
};

export const DECLARATION_KIND = {
  UNSIGNED: 'UNSIGNED',
  SIGNED: 'SIGNED',
} as const;

export type DeclarationKind =
  (typeof DECLARATION_KIND)[keyof typeof DECLARATION_KIND];

export const DECLARATION_KIND_LABELS: Record<DeclarationKind, string> = {
  [DECLARATION_KIND.UNSIGNED]: 'Unsigned',
  [DECLARATION_KIND.SIGNED]: 'Signed',
};

export const TAX_FILINGS_TAB = {
  TAX_SUMMARY: 'tax-summary',
  DRAFT_COPIES: 'draft-copies',
  DECLARATION: 'declaration',
  FINAL_COPIES: 'final-copies',
} as const;

export type TaxFilingsTab =
  (typeof TAX_FILINGS_TAB)[keyof typeof TAX_FILINGS_TAB];

export const TAX_FILINGS_TAB_VALUES: TaxFilingsTab[] = Object.values(
  TAX_FILINGS_TAB
);

/** Raw document from list APIs. */
export interface TaxFilingDocumentApi {
  _id?: string;
  name: string;
  type?: string;
  size?: string;
  createdAt?: string;
  lastModifiedBy?: string;
  status?: string;
  rejectionComment?: string;
  kind?: string;
}

/** Normalized tax filing document. */
export interface TaxFilingDocument {
  id: string;
  name: string;
  size: number;
  mimeType: string;
  createdAt?: string;
  lastModifiedBy?: string;
  status?: DraftCopyStatus;
  rejectionComment?: string;
  kind?: DeclarationKind;
}

/** Preview response (GET /:id). */
export interface TaxFilingPreviewResponse {
  _id?: string;
  name?: string;
  url: string;
}

/** Upload response (POST declarations). */
export interface TaxFilingUploadUrlResponse {
  name?: string;
  key: string;
  uploadUrl: string;
  _id?: string;
}
